import React, { useState } from "react";

import Handshake from "../../../assets/images/icona-pag13.svg";

/* Accordion "Global context / Market / Regulation".
   Stessa logica del Modello di Business (pointy-box + pannello flottante),
   ricolorato in oro/navy. */

const GOLD = "#f0b500";
const NAVY = "#0E3761";

const SECTIONS = [
  {
    key: "Global context",
    items: [
      "2030 Agenda of the United Nations",
      "Technological innovation and AI",
      "Global geopolitical tensions",
      "Climate change",
    ],
  },
  {
    key: "Market",
    items: [
      "Trends in insurance, financial, banking and real estate markets",
    ],
  },
  {
    key: "Regulation",
    items: [
      <><b>Insurance regulation:</b> Solvency II Review (EU Directive 2025/2), CatNat (Law 78/2025), Insurance Arbitrator (Decree 215/2024 and IVASS Provisions), Recovery and Resolution (EU Directive 2025/1)</>,
      <><b>ICT regulation:</b> AI Act (EU Regulation 2024/1689 and Law 132/2025), Dora, Data Act (EU Regulation 2023/2854)</>,
      <><b>Anti-money laundering:</b> AML Package & the new European Authority</>,
      <><b>Fiscal and State Budget:</b> Global Minimum Tax (MEF Decrees 2024-2025), Insurance Tax Updates (2025 and 2026 Budget Laws), Tax Control Framework (Revenue Agency Provision 7 August 2025), Transition and Employment Incentives (2025 Budget Law)</>,
      <><b>Sustainable Finance and transparent communication:</b> CSRD and ESRS, Omnibus and Stop the Clock, Quick Fix, Empowering Consumers for the Green Transition, Green Claims Directive</>,
    ],
  },
];

/* Pannello flottante ancorato sopra al pointy-box */
function Panel({ title, items, onClose }) {
  return (
    <div
      className="absolute left-1/2 -translate-x-1/2 top-0 z-[40] w-[96%] max-w-[640px]"
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className="relative rounded-[14px] shadow-xl border-[2px] bg-white px-5 md:px-7 py-5 max-h-[60vh] overflow-y-auto"
        style={{ borderColor: GOLD }}
        role="dialog"
        aria-label={title}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute right-3 top-2 text-2xl leading-none"
          style={{ color: GOLD }}
          aria-label="Close"
          title="Close"
        >
          –
        </button>

        <div
          className="text-left font-bold uppercase text-[14px] md:text-[20px] mb-3 pr-6"
          style={{ color: GOLD }}
        >
          {title}
        </div>

        <ul
          className="text-left text-[13px] md:text-[16px] leading-[1.35] list-disc pl-5 space-y-2"
          style={{ color: NAVY }}
        >
          {items.map((t, i) => (
            <li key={i}>{t}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function ContestoAccordion() {
  const [openKey, setOpenKey] = useState(null);
  const active = SECTIONS.find((s) => s.key === openKey);

  return (
    <div className="relative w-full mb-12 md:mb-16">
      {/* pointy-box giallo (punta verso il basso) */}
      <div
        className="pointy-box relative flex flex-col gap-3 md:gap-4 border-[5px] p-5 md:p-6 w-[400px] max-w-full h-[300px] md:h-[400px] mx-auto"
        style={{
          borderColor: GOLD,
          borderRadius: "15px 15px 50px 50px",
          "--pointy-color": GOLD,
          "--pointy-w": "36px",
          "--pointy-h": "30px",
          "--pointy-bottom": "-30px",
        }}
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        {SECTIONS.map((s) => {
          const isOpen = openKey === s.key;
          return (
            <button
              key={s.key}
              type="button"
              aria-expanded={isOpen}
              onClick={() => setOpenKey(isOpen ? null : s.key)}
              className="flex items-center justify-between gap-3 font-bold uppercase text-[15px] md:text-[24px] hover:opacity-80 transition"
              style={{ color: NAVY }}
            >
              <span className="text-left">{s.key}</span>
              <span className="text-[22px] md:text-[30px] leading-none">{isOpen ? "–" : "+"}</span>
            </button>
          );
        })}

        {/* illustrazione in fondo al box */}
        <img
          src={Handshake}
          alt=""
          className="pointer-events-none select-none absolute -bottom-[26px] left-1/2 -translate-x-1/2 w-[90%]"
        />
      </div>

      {active && (
        <Panel title={active.key} items={active.items} onClose={() => setOpenKey(null)} />
      )}
    </div>
  );
}
